const systemBtnsToggler = document.querySelector('.system-btns__toggler');
const systemBtnsContent = document.querySelector('.system-btns__content');

systemBtnsToggler.addEventListener('pointerup', () => {
    systemBtnsContent.classList.toggle('open');
});
